


















































import Component from 'vue-class-component'
import { Vue, Prop, Emit } from 'vue-property-decorator'
import { ChartData, ChartOptions } from 'chart.js'
import Chart from '@/components/Chart.vue'

@Component({
  components: {
    Chart
  }
})
export default class ProductSuggest extends Vue {
  @Prop()
  dialog = false

  @Prop()
  values?: number[]

  @Prop()
  item?: any

  @Prop()
  typePoint?: number[]

  @Emit()
  public parentDataReset () {
    this.$emit('handle-parent', false)
  }

  get localDialog () {
    return this.dialog
  }

  set localDialog (value: boolean) {
    this.parentDataReset()
  }

  get localValues () {
    if (this.values !== undefined) {
      return this.values.map((point: number) => point * 0.75)
    } else {
      return [5, 5, 5, 5, 5]
    }
  }

  public closeModal () {
    this.parentDataReset()
  }

  private chartData: ChartData = {
    labels: ['泡立ち', '頭皮への優しさ', '髪の補修力', '安全性', '　　仕上がり'],
    datasets: [
      {
        label: 'シャンプー',
        data: this.localValues,
        backgroundColor: [
          'rgba(0, 173, 181, 0.5)'
        ],
        borderColor: [
          'rgba(0, 173, 181, 1)'
        ],
        borderWidth: 1
      },
      {
        label: 'アナタ',
        data: this.typePoint,
        backgroundColor: [
          'rgba(255, 190, 11, 0.5)'
        ],
        borderColor: [
          'rgba(255, 190, 11, 1)'
        ],
        borderWidth: 1
      }
    ]
  }

  private chartOption: ChartOptions = {
    scale: {
      angleLines: {
        display: false
      },
      ticks: {
        suggestedMin: 0,
        suggestedMax: 6
      }
    },
    legend: {
      display: true,
      position: 'bottom'
    },
    title: {
      display: true,
      text: 'シャンプーとアナタの相性',
      fontSize: 13,
      fontColor: '#000000'
    }
  }

  public openWindow (url: string) {
    this.$ga.event('amzonLinkButtonInModal', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }
}
